import {FC} from 'react'

/**
 * Small inline spinner for buttons during async actions. Uses the `ccpSpin`
 * keyframe defined by ToastProvider (mounted app-wide).
 */
export const Spinner: FC<{size?: number; color?: string}> = ({size = 15, color = 'currentColor'}) => (
  <span
    aria-hidden='true'
    style={{
      display: 'inline-block',
      width: size,
      height: size,
      border: `2px solid ${color}`,
      borderTopColor: 'transparent',
      borderRadius: '50%',
      animation: 'ccpSpin 0.7s linear infinite',
      verticalAlign: 'middle',
    }}
  />
)
